var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.768,
    height: 21.023,
    viewBox: "0 0 15.768 21.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "page_settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-alt",
    "data-name": "Icon awesome-file-alt",
    d: "M9.2,5.584V0H.985A.983.983,0,0,0,0,.985V20.038a.983.983,0,0,0,.985.985h13.8a.983.983,0,0,0,.985-.985V6.57H10.183A.988.988,0,0,1,9.2,5.584Zm2.628,9.69a.494.494,0,0,1-.493.493h-6.9a.494.494,0,0,1-.493-.493v-.328a.494.494,0,0,1,.493-.493h6.9a.494.494,0,0,1,.493.493Zm0-2.628a.494.494,0,0,1-.493.493h-6.9a.494.494,0,0,1-.493-.493v-.328a.494.494,0,0,1,.493-.493h6.9a.494.494,0,0,1,.493.493Zm0-2.956v.328a.494.494,0,0,1-.493.493h-6.9a.494.494,0,0,1-.493-.493V9.69A.494.494,0,0,1,4.435,9.2h6.9A.494.494,0,0,1,11.826,9.69Zm3.942-4.685v.25H10.512V0h.25a.985.985,0,0,1,.7.287l4.02,4.024A.982.982,0,0,1,15.768,5.005Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageSettings);
export default __webpack_public_path__ + "static/media/page_settings.2836055e5906c99b6bba98ad718a284f.svg";
export { ForwardRef as ReactComponent };